import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMyself = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.1779 3.03613C9.82928 3.03613 7.91992 4.94549 7.91992 7.2941C7.91992 9.59788 9.72171 11.4624 12.0703 11.5431C12.142 11.5341 12.2137 11.5341 12.2675 11.5431C12.2855 11.5431 12.2944 11.5431 12.3123 11.5431C12.3213 11.5431 12.3213 11.5431 12.3303 11.5431C14.6251 11.4624 16.4269 9.59788 16.4358 7.2941C16.4358 4.94549 14.5265 3.03613 12.1779 3.03613Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.7317 13.9273C14.2307 12.2599 10.152 12.2599 7.63312 13.9273C6.49468 14.6892 5.86719 15.7201 5.86719 16.8227C5.86719 17.9253 6.49468 18.9472 7.62416 19.7002C8.87914 20.5428 10.5285 20.9641 12.1779 20.9641C13.8273 20.9641 15.4767 20.5428 16.7317 19.7002C17.8612 18.9382 18.4887 17.9163 18.4887 16.8047C18.4797 15.7022 17.8612 14.6802 16.7317 13.9273Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgMyself);
export default ForwardRef;
